import vue from "vue";

const banner= async (payload) => {
  const res = await vue.axios.post(`advertisement/get-ad-v2`, payload);
  return res.data;
};

export { banner };
